import { VALIDATE_TRIP_ROUTE_FOR_OTA_URL } from "../../utils/api-url";
import { postCall } from "../../utils/network.util"


export const validateOtaAction =(tripRouteId,onSuccess,onFailure)=>{
    postCall(VALIDATE_TRIP_ROUTE_FOR_OTA_URL,{tripRouteId:tripRouteId}).then((data)=>{
        if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
            onSuccess(data.payload.Message);
        }else{
            onFailure(data.payload.Message);
        }
    }).catch((error)=>{
        onFailure(error);
    })
}